export default __webpack_public_path__ + "static/media/binnenklimaattechiek.106a83b3.svg";